import ViewCustomer from "./ViewCustomer";
import './viewCustomer.scss';

export default ViewCustomer;